<div fxLayout="column" class= "scroll-hidden" layout-align="start stretch">
  <div fxFlex="80"><app-home></app-home></div>
 <!-- <div fxFlex ><app-footer ></app-footer></div>-->
</div>
